export default __webpack_public_path__ + "static/media/personIdea.77e98a0e.svg";